import { FaChevronLeft, FaChevronRight } from "react-icons/fa"
import { HStack, IconButton } from "@chakra-ui/react"
import { Button } from "./Button"
import { Text } from "./Text"

interface PaginationControlsProps {
  currentPage: number
  totalPages: number
  totalItems: number
  startIndex: number
  endIndex: number
  onPageChange: (page: number) => void
  getPageNumbers: () => (number | string)[]
}

export const PaginationControls = ({
  currentPage,
  totalPages,
  totalItems,
  startIndex,
  endIndex,
  onPageChange,
  getPageNumbers,
}: PaginationControlsProps) => {
  if (totalPages <= 1) return null

  return (
    <HStack mt={4} justifyContent="space-between" alignItems="center">
      <Text fontSize="sm" color="text.muted">
        Showing {startIndex + 1} - {Math.min(endIndex, totalItems)} of {totalItems}
      </Text>
      <HStack gap={1}>
        <IconButton
          aria-label="Previous page"
          size="sm"
          variant="outline"
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          <FaChevronLeft />
        </IconButton>
        {getPageNumbers().map((page, index) =>
          typeof page === "number" ? (
            <Button
              key={index}
              size="sm"
              variant={currentPage === page ? "solid" : "outline"}
              colorScheme={currentPage === page ? "blue" : "gray"}
              onClick={() => onPageChange(page)}
            >
              {page}
            </Button>
          ) : (
            <Text key={index} px={2} color="text.muted">
              {page}
            </Text>
          )
        )}
        <IconButton
          aria-label="Next page"
          size="sm"
          variant="outline"
          disabled={currentPage === totalPages}
          onClick={() => onPageChange(currentPage + 1)}
        >
          <FaChevronRight />
        </IconButton>
      </HStack>
    </HStack>
  )
}
